import PersistentStoreService, {
  ClassSerializerFactory
} from "@soenergy/frontend-library/src/services/PersistentStoreService"
import DayJSSerializer from "@soenergy/frontend-library/src/services/PersistentStoreService/DayJSSerializer.js"
import TariffQuoteV2 from "@soenergy/frontend-library/src/models/TariffQuoteV2"

let store = null

export default (context, inject) => {
  if (context) {
    store = context.store

    PersistentStoreService.init({
      store,
      serializers: [
        DayJSSerializer,
        ClassSerializerFactory(TariffQuoteV2, "TariffQuoteV2")
      ],
      reducer: state => ({
        quote: {
          meterEvEligibilityError: state.quote.meterEvEligibilityError,
          referralDetails: state.quote.referralDetails,
          form: state.quote.form,
          furthestCompletedStep: state.quote.furthestCompletedStep,
          selectedQuote: state.quote.selectedQuote
        }
      })
    })
  }
}

export const getStore = () => {
  return store
}
